import { Box, TableCell, TableRow } from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import Checkbox from '@mui/material/Checkbox';
import { visuallyHidden } from '@mui/utils';
import { Key } from 'react';
import { HeadCell, Order } from './types';


interface EnhancedTableProps {
    headCells: HeadCell[];
    selectable: boolean;
    actionable?: boolean;
    numSelected?: number;
    onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
    onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
}

const EnhancedTableHead = (props: EnhancedTableProps) => {
    
    const {headCells, selectable, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    let isActionable = props?.actionable === undefined ? true : props.actionable;
    
    const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {selectable && 
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected ? (numSelected > 0 && numSelected < rowCount) : undefined}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}                        
                    />
                </TableCell>}
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id as Key}
                        align={headCell.numeric ? 'right' : 'left'}
                        width={headCell.width}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {headCell.disableSort // If disableSorting is true, then don't show the sort icon
                            ? headCell.label
                            :
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        }
                    </TableCell>
                ))}
                {isActionable && <TableCell />}
            </TableRow>
        </TableHead>
    );
};

export default EnhancedTableHead;